import {Dna} from "react-loader-spinner";

const DNALoader = (height, width) => {

  return(
    <Dna 
      visible={true} 
      height={height || '120'} 
      width={width || '120'} 
      ariaLabel="dna-loading" 
      wrapperClass="dna-wrapper"
    />
  );
  
};
export default DNALoader;